export default __webpack_public_path__ + "static/media/KLbyProvVertical.0b57caa2.png";